import { useMemo } from 'react';

import { TFunction } from 'i18next';

export interface PasswordRequirement {
  label: string;
  satisfied: boolean;
}

export function usePasswordRequirements(password: string, t: TFunction): PasswordRequirement[] {
  return useMemo(
    () => [
      {
        label: t('passwordRequirementMinLength'),
        satisfied: password.length >= 8,
      },
      {
        label: t('passwordRequirementUppercase'),
        satisfied: /[A-Z]/.test(password),
      },
      {
        label: t('passwordRequirementLowercase'),
        satisfied: /[a-z]/.test(password),
      },
      {
        label: t('passwordRequirementNumber'),
        satisfied: /\d/.test(password),
      },
    ],
    [password, t]
  );
}
